import React, { Component } from 'react';
import Driver from './driver.jsx';
import moment from 'moment';
export default class DriversTable extends Component {  
  constructor(props) {
    super(props);
    this.state = {
      drivers: props.drivers || null,
      isLoading: !props.drivers,
      url: props.url || null,
      viewJustOneDriver: props.viewJustOneDriver || false,
      viewAllJobs: props.viewAllJobs || false,
      jobs: props.jobs || [],
      setLateDriverMsg: [],
      lateDriverJobIds: [],
      filterCompany: null,
      infiniteScroll: props.infiniteScroll || false,
      isDriverDashboardPage: props.isDriverDashboardPage || false,
      noOfOverdueMoves: 0,
      movesOverdueIn24Hours: 0,
      overdueJobs: {},
      overdueJobsIn24hours: {},
      stopRerender: false,
    };
    this.handleLateDrivers = this.handleLateDrivers.bind(this);
    this.saveLateJobIdsOFDriver = this.saveLateJobIdsOFDriver.bind(this);
    this.handleAddOrderByInUser = this.handleAddOrderByInUser.bind(this);
    this.handleRerenderTrigger = this.handleRerenderTrigger.bind(this);
  }
  getDrivers() {
    return fetch(this.state.url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    }).
      then((responseText) => {
        let response = responseText.json();
        response.then((response) => {

          if ((this.state.viewJustOneDriver === true) &&
            (this.state.viewAllJobs === true)) {
            this.setState({
              drivers: response,
              isLoading: false
            });
          }
          else {
            this.setState({
              drivers: response,
              isLoading: false
            });
          }
        });
        return response;
      });
  }
  componentDidMount() {
    // [TODO] add realtime stuff
    if (this.state.isLoading === true) {
      this.getDrivers().then(function (drivers) {
        
        if (this.state.isDriverDashboardPage) {
          const prioritisedDrivers = drivers.map((user) => this.handleAddOrderByInUser(user));
          this.setState({ drivers: _.orderBy(prioritisedDrivers,'last_job_scheduled_dropoff_date','asc') });
        }
      }.bind(this));
    }
    this.smoothScrollToHash();
      window.addEventListener('hashchange', this.smoothScrollToHash);
  }
  componentWillUnmount(){
      window.removeEventListener('hashchange', this.smoothScrollToHash);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      drivers: nextProps.drivers
    });
  }
  saveLateJobIdsOFDriver(jobsID) {

    if (!this.state.lateDriverJobIds.includes(jobsID)) {
      var joined = this.state.lateDriverJobIds.concat(jobsID);
      this.setState({ lateDriverJobIds: joined }, () => {
        return fetch('/api/v1/portal/jobs/latedriver/updatejob/' + jobsID, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).
          then((responseText) => {
            let response = responseText.json();
          });
      });
    }
  }
  handleLateDrivers(someval, driverID) {

    if (someval !== null) {
      if (this.state.setLateDriverMsg.indexOf(someval) == -1) {
        this.setState({
          setLateDriverMsg: [...this.state.setLateDriverMsg, someval]
        });
      }
    }
    if (this.state.drivers.length > 0) {

      let lastDriver = this.state.drivers.slice(-1).pop();
      if (driverID == lastDriver.id) {

        if (this.state.setLateDriverMsg.length > 0) {
          let infoModal = $('#infomodal');
          $('#infomodallabel').html('Drivers Lists');
          $('#infomodal .modal-body').html("<div className='alert alert-danger'>" + this.state.setLateDriverMsg + "</div>");
          infoModal.modal();
        }
      }
    }
    return false;
  }
  handleCompanyFilter(ele) {
    this.setState({
      filterCompany: ele.target.value
    });
    if (ele.target.value == 'acv') {
      $(".filter-acv").show();
      $(".filter-cnd").hide();
      $(".filter-acv-truck").hide();
    }
    if (ele.target.value == 'cnd') {
      $(".filter-acv").hide();
      $(".filter-cnd").show();
      $(".filter-acv-truck").hide();
    }
    if (ele.target.value == 'acv-truck') {
      $(".filter-acv").hide();
      $(".filter-cnd").hide();
      $(".filter-acv-truck").show();
    }  
  }
  handleAddOrderByInUser(user){
    if (user && user.driver) {
      const lastJobOfDriver = _.last(user.driver.jobs);
      if (!lastJobOfDriver) {
        user['last_job_scheduled_dropoff_date'] = moment().add(-1, 'month').format("YYYY-MM-DD HH:mm:ss");
      } else {
        user['last_job_scheduled_dropoff_date'] = moment(lastJobOfDriver.scheduled_dropoff_date).format("YYYY-MM-DD HH:mm:ss");
      }
    }
    return user;
  }
  handleRerenderTrigger(jobs, driver_id, driver) {
    this.setState((prevState) => {
      const updatedDrivers = prevState.drivers.map((user) => {
        if (user.id === driver_id) {
          user = { ...user, driver: driver };
          return { ...user, driver: { ...user.driver, jobs } };
        }
        return user;
      });
  
      return { drivers: updatedDrivers, stopRerender: false };
    });
    let drivers = this.state.drivers;
    const prioritisedDrivers = drivers.map((user) => this.handleAddOrderByInUser(user));
    this.setState({ drivers: _.orderBy(prioritisedDrivers,'last_job_scheduled_dropoff_date','asc') });
  }

  smoothScrollToHash = () => {
    if (this.props.isSchedulePage) {
      const getOffsetTop = function(element) {
        if (!element) return 0;
        return element.offsetTop + getOffsetTop(element.offsetParent);
      };
      const hash = window.location.hash.substring(1);
      if (hash) {
        this.scrollToHashWhenReady(hash, getOffsetTop);
      }
    }
  };
  scrollToHashWhenReady = (hash, getOffsetTop) => {
    const targetElement = document.querySelector('#' + hash);
    if (targetElement) {
      const navBarHeight = 150;
      const offsetTop = getOffsetTop(targetElement) - navBarHeight;
      // console.log(hash, offsetTop);
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
    } else {
      // Use MutationObserver to wait for the target element to be available
      const observer = new MutationObserver((mutations, obs) => {
        const targetElement = document.querySelector('#' + hash);
        if (targetElement) {
          const navBarHeight = 150;
          const offsetTop = getOffsetTop(targetElement) - navBarHeight;
          // console.log(hash, offsetTop);
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth',
          });
          obs.disconnect();
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  };
  
  render() {
    let Drivers = [];
    let DriversNewCol = [];
    let viewAllJobs = this.state.viewAllJobs;
    let handleLateDriversFunc = this.handleLateDrivers;
    let saveLateJobIdsOFDriverFunc = this.saveLateJobIdsOFDriver;
    let infiniteScroll = this.state.infiniteScroll;
    let isDriverDashboardPage = this.state.isDriverDashboardPage;
    let handleRerenderTriggerFunc = this.handleRerenderTrigger;
    if (this.state.drivers && this.state.drivers.length > 0) {
      this.state.drivers.forEach(function(i,j) {
        if (i && i.driver) {
          if(j > 40 && isDriverDashboardPage){
            DriversNewCol.push(
              <Driver
                key={'driver-' + i.id}
                data={i}
                jobs={i.jobs}
                infiniteScroll={infiniteScroll}
                viewAllJobs={viewAllJobs}
                handleLateDrivers={handleLateDriversFunc}
                saveLateJobIdsOFDriver={saveLateJobIdsOFDriverFunc}
                isDriverDashboardPage={isDriverDashboardPage}
                // handleDriverStatestics={handleDriverStatesticsFunc}
                handleRerenderTrigger={handleRerenderTriggerFunc}
              />
            );
          } else {
            Drivers.push(
              <Driver
                key={'driver-' + i.id}
                data={i}
                jobs={i.jobs}
                infiniteScroll={infiniteScroll}
                viewAllJobs={viewAllJobs}
                handleLateDrivers={handleLateDriversFunc}
                saveLateJobIdsOFDriver={saveLateJobIdsOFDriverFunc}
                isDriverDashboardPage={isDriverDashboardPage}
                // handleDriverStatestics={handleDriverStatesticsFunc}
                handleRerenderTrigger={handleRerenderTriggerFunc}
              />
            );
          }
          
        }
      });
      if(!this.state.viewJustOneDriver && !this.state.isDriverDashboardPage){
        if(loginCompany == 'cnd' || loginCompany == 'acv' || loginCompany == 'acv-truck'){ 
          Drivers.unshift(<div className="row align-items-center">
            <div className="col-"><h4><b>Filter :</b></h4></div>
            <div className="col-11">
              <div className="btn-group btn-group-toggle" id="filter-company">
                <label className={"btn mt-2 mb-2 " + (this.state.filterCompany == 'cnd' ? ' btn-primary active ' : ' btn-secondary ')} id="filter_company-cnd">
                  <input defaultChecked={(this.state.filterCompany == 'cnd') ? true : false}
                    className="form-control form-control-lg" name="filter_company"
                    onChange={(e) => this.handleCompanyFilter(e)} type="radio" value="cnd" /> CND</label>
                <label className={"btn mt-2 mb-2 " + (this.state.filterCompany == 'acv' ? ' btn-primary active ' : ' btn-secondary ')} id="filter_company-acv">
                  <input defaultChecked={(this.state.filterCompany == 'acv') ? true : false}
                    className="form-control form-control-lg" name="filter_company"
                    onChange={(e) => this.handleCompanyFilter(e)} type="radio" value="acv" /> ACV</label>
                <label className={"btn mt-2 mb-2 " + (this.state.filterCompany == 'acv-truck' ? ' btn-primary active ' : ' btn-secondary ')} id="filter_company-acv-truck">
                  <input defaultChecked={(this.state.filterCompany == 'acv-truck') ? true : false}
                    className="form-control form-control-lg" name="filter_company"
                    onChange={(e) => this.handleCompanyFilter(e)} type="radio" value="acv-truck" /> ACV Truck</label>
              </div>
            </div>
          </div>)
        }
      }
    }
    return (
      <div className="drivers-table">
        <div className="tab-content-container main-tab-content-container">
          {
            this.state.isLoading ?
              (<div className="loading-box">
                <span className="add-loading-text">
                  <i className="fa fa-spinner fa-pulse"></i>
                </span>
              </div>) :
              ((this.state.isDriverDashboardPage) ? 
                <div className="row">
                <div className="col-6 no-padding">{Drivers}</div>
                <div className="col-6 no-padding">{DriversNewCol}</div>
              </div> : 
              Drivers
            )
          }
        </div>
      </div>
    );
  }
}
